"use client";
import { Box, Button, Icon, ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem } from "@mui/material";

import { LogoutOutlined } from "@mui/icons-material";
import React from "react";
import { signOut } from "next-auth/react";
import LogoutIcon from "./Icons/LogoutIcon";

export default function ExitMenu({ listItem, dark }: { listItem?: boolean; dark?: boolean }) {
  if (listItem) {
    return (
      <ListItem disablePadding>
        <ListItemButton
          onClick={async () => {
            await signOut({ redirect: true, callbackUrl: "/" });
          }}
        >
          <ListItemIcon
            sx={{
              justifyContent: "center",
              color: "primary.main", // Dynamic color for sub-items
            }}
          >
            <Icon>
              <LogoutIcon />
            </Icon>
          </ListItemIcon>
          <ListItemText primary={"خروج"} />
        </ListItemButton>
      </ListItem>
    );
  }

  return (
    <MenuItem
      sx={{
        ...(dark && { color: "white.main" }),
      }}
      onClick={async () => {
        await signOut();
      }}
    >
      <ListItemIcon
        sx={{
          color: "grey.800",
          ...(dark && { color: "white.main" }),
        }}
      >
        <Icon
          sx={{
            ...(dark && { color: "white.main" }),
          }}
        >
          <LogoutIcon />
        </Icon>
      </ListItemIcon>
      خروج
    </MenuItem>
  );
}
